import { c as _c } from "react-compiler-runtime";
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type { DataTag, DefinedInitialDataOptions, DefinedUseQueryResult, MutationFunction, QueryClient, QueryFunction, QueryKey, UndefinedInitialDataOptions, UseMutationOptions, UseMutationResult, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import type { CaptureConsentRequest, CaptureMarketingSmsConsentForAssessmentRequest, ProblemDetails } from "../model";
import { retrieveData } from "../../custom-fetch";
import type { ErrorType, BodyType } from "../../custom-fetch";
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];
const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & {
  queryKey: K;
} => {
  const result = {
    queryKey
  } as T & {
    queryKey: K;
  };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};
export const getCaptureBiometricConsentUrl = (personId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/biometric/persons/${personId}/platforms/${platformId}`;
};

/**
 * @summary Captures biometric consent for a person on a platform.
 */
export const captureBiometricConsent = async (personId: string, platformId: string, captureConsentRequest?: CaptureConsentRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getCaptureBiometricConsentUrl(personId, platformId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(captureConsentRequest)
  });
};
export const getCaptureBiometricConsentMutationKey = () => ["captureBiometricConsent"] as const;
export const getCaptureBiometricConsentMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof captureBiometricConsent>>, TError, CaptureBiometricConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof captureBiometricConsent>>, TError, CaptureBiometricConsentMutationVariables, TContext> => {
  const mutationKey = getCaptureBiometricConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureBiometricConsent>>, CaptureBiometricConsentMutationVariables> = props => {
    const {
      personId,
      platformId,
      data
    } = props ?? {};
    return captureBiometricConsent(personId, platformId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type CaptureBiometricConsentMutationResult = NonNullable<Awaited<ReturnType<typeof captureBiometricConsent>>>;
export type CaptureBiometricConsentMutationBody = BodyType<CaptureConsentRequest> | undefined;
export type CaptureBiometricConsentMutationError = ErrorType<unknown>;
export type CaptureBiometricConsentMutationVariables = {
  personId: string;
  platformId: string;
  data?: BodyType<CaptureConsentRequest>;
};

/**
 * @summary Captures biometric consent for a person on a platform.
 */
export const useCaptureBiometricConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getCaptureBiometricConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getRevokeBiometricConsentUrl = (personId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/biometric/persons/${personId}/platforms/${platformId}`;
};

/**
 * @summary Revokes biometric consent for a person on a platform.
 */
export const revokeBiometricConsent = async (personId: string, platformId: string, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  return retrieveData<void>(getRevokeBiometricConsentUrl(personId, platformId), {
    ...options,
    method: "DELETE"
  });
};
export const getRevokeBiometricConsentMutationKey = () => ["revokeBiometricConsent"] as const;
export const getRevokeBiometricConsentMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof revokeBiometricConsent>>, TError, RevokeBiometricConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof revokeBiometricConsent>>, TError, RevokeBiometricConsentMutationVariables, TContext> => {
  const mutationKey = getRevokeBiometricConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeBiometricConsent>>, RevokeBiometricConsentMutationVariables> = props => {
    const {
      personId,
      platformId
    } = props ?? {};
    return revokeBiometricConsent(personId, platformId, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type RevokeBiometricConsentMutationResult = NonNullable<Awaited<ReturnType<typeof revokeBiometricConsent>>>;
export type RevokeBiometricConsentMutationError = ErrorType<unknown>;
export type RevokeBiometricConsentMutationVariables = {
  personId: string;
  platformId: string;
};

/**
 * @summary Revokes biometric consent for a person on a platform.
 */
export const useRevokeBiometricConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getRevokeBiometricConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getCaptureConsumerHealthConsentUrl = (personId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/consumer-health/persons/${personId}/platforms/${platformId}`;
};

/**
 * @summary Captures consumer health consent for a person on a platform.
 */
export const captureConsumerHealthConsent = async (personId: string, platformId: string, captureConsentRequest?: CaptureConsentRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getCaptureConsumerHealthConsentUrl(personId, platformId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(captureConsentRequest)
  });
};
export const getCaptureConsumerHealthConsentMutationKey = () => ["captureConsumerHealthConsent"] as const;
export const getCaptureConsumerHealthConsentMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof captureConsumerHealthConsent>>, TError, CaptureConsumerHealthConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof captureConsumerHealthConsent>>, TError, CaptureConsumerHealthConsentMutationVariables, TContext> => {
  const mutationKey = getCaptureConsumerHealthConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureConsumerHealthConsent>>, CaptureConsumerHealthConsentMutationVariables> = props => {
    const {
      personId,
      platformId,
      data
    } = props ?? {};
    return captureConsumerHealthConsent(personId, platformId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type CaptureConsumerHealthConsentMutationResult = NonNullable<Awaited<ReturnType<typeof captureConsumerHealthConsent>>>;
export type CaptureConsumerHealthConsentMutationBody = BodyType<CaptureConsentRequest> | undefined;
export type CaptureConsumerHealthConsentMutationError = ErrorType<unknown>;
export type CaptureConsumerHealthConsentMutationVariables = {
  personId: string;
  platformId: string;
  data?: BodyType<CaptureConsentRequest>;
};

/**
 * @summary Captures consumer health consent for a person on a platform.
 */
export const useCaptureConsumerHealthConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getCaptureConsumerHealthConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getRevokeConsumerHealthConsentUrl = (personId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/consumer-health/persons/${personId}/platforms/${platformId}`;
};

/**
 * @summary Revokes consumer health consent for a person on a platform.
 */
export const revokeConsumerHealthConsent = async (personId: string, platformId: string, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  return retrieveData<void>(getRevokeConsumerHealthConsentUrl(personId, platformId), {
    ...options,
    method: "DELETE"
  });
};
export const getRevokeConsumerHealthConsentMutationKey = () => ["revokeConsumerHealthConsent"] as const;
export const getRevokeConsumerHealthConsentMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof revokeConsumerHealthConsent>>, TError, RevokeConsumerHealthConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof revokeConsumerHealthConsent>>, TError, RevokeConsumerHealthConsentMutationVariables, TContext> => {
  const mutationKey = getRevokeConsumerHealthConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeConsumerHealthConsent>>, RevokeConsumerHealthConsentMutationVariables> = props => {
    const {
      personId,
      platformId
    } = props ?? {};
    return revokeConsumerHealthConsent(personId, platformId, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type RevokeConsumerHealthConsentMutationResult = NonNullable<Awaited<ReturnType<typeof revokeConsumerHealthConsent>>>;
export type RevokeConsumerHealthConsentMutationError = ErrorType<unknown>;
export type RevokeConsumerHealthConsentMutationVariables = {
  personId: string;
  platformId: string;
};

/**
 * @summary Revokes consumer health consent for a person on a platform.
 */
export const useRevokeConsumerHealthConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getRevokeConsumerHealthConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getCapturePromotionalMarketingConsentUrl = (personId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/promotional-marketing/persons/${personId}/platforms/${platformId}`;
};

/**
 * @summary Captures promotional marketing consent for a person on a platform.
 */
export const capturePromotionalMarketingConsent = async (personId: string, platformId: string, captureConsentRequest?: CaptureConsentRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getCapturePromotionalMarketingConsentUrl(personId, platformId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(captureConsentRequest)
  });
};
export const getCapturePromotionalMarketingConsentMutationKey = () => ["capturePromotionalMarketingConsent"] as const;
export const getCapturePromotionalMarketingConsentMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof capturePromotionalMarketingConsent>>, TError, CapturePromotionalMarketingConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof capturePromotionalMarketingConsent>>, TError, CapturePromotionalMarketingConsentMutationVariables, TContext> => {
  const mutationKey = getCapturePromotionalMarketingConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof capturePromotionalMarketingConsent>>, CapturePromotionalMarketingConsentMutationVariables> = props => {
    const {
      personId,
      platformId,
      data
    } = props ?? {};
    return capturePromotionalMarketingConsent(personId, platformId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type CapturePromotionalMarketingConsentMutationResult = NonNullable<Awaited<ReturnType<typeof capturePromotionalMarketingConsent>>>;
export type CapturePromotionalMarketingConsentMutationBody = BodyType<CaptureConsentRequest> | undefined;
export type CapturePromotionalMarketingConsentMutationError = ErrorType<unknown>;
export type CapturePromotionalMarketingConsentMutationVariables = {
  personId: string;
  platformId: string;
  data?: BodyType<CaptureConsentRequest>;
};

/**
 * @summary Captures promotional marketing consent for a person on a platform.
 */
export const useCapturePromotionalMarketingConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getCapturePromotionalMarketingConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getRevokePromotionalMarketingConsentUrl = (personId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/promotional-marketing/persons/${personId}/platforms/${platformId}`;
};

/**
 * @summary Revokes promotional marketing consent for a person on a platform.
 */
export const revokePromotionalMarketingConsent = async (personId: string, platformId: string, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  return retrieveData<void>(getRevokePromotionalMarketingConsentUrl(personId, platformId), {
    ...options,
    method: "DELETE"
  });
};
export const getRevokePromotionalMarketingConsentMutationKey = () => ["revokePromotionalMarketingConsent"] as const;
export const getRevokePromotionalMarketingConsentMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof revokePromotionalMarketingConsent>>, TError, RevokePromotionalMarketingConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof revokePromotionalMarketingConsent>>, TError, RevokePromotionalMarketingConsentMutationVariables, TContext> => {
  const mutationKey = getRevokePromotionalMarketingConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokePromotionalMarketingConsent>>, RevokePromotionalMarketingConsentMutationVariables> = props => {
    const {
      personId,
      platformId
    } = props ?? {};
    return revokePromotionalMarketingConsent(personId, platformId, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type RevokePromotionalMarketingConsentMutationResult = NonNullable<Awaited<ReturnType<typeof revokePromotionalMarketingConsent>>>;
export type RevokePromotionalMarketingConsentMutationError = ErrorType<unknown>;
export type RevokePromotionalMarketingConsentMutationVariables = {
  personId: string;
  platformId: string;
};

/**
 * @summary Revokes promotional marketing consent for a person on a platform.
 */
export const useRevokePromotionalMarketingConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getRevokePromotionalMarketingConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getGetPersonalConsentUrl = (personId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/persons/${personId}/platforms/${platformId}`;
};

/**
 * @summary Retrieves personal consent information for a person on a specific platform.

Returns 204 No Content when no consent row exists for the
person+platform pair (rather than 404). The shared CloudFront
distribution rewrites 4xx responses to `index.html` for SPA
routing, which would mask a 404 from this endpoint as an HTML payload;
204 sidesteps that. Splitting the API onto its own distribution is
tracked as follow-up work.

A missing row is the expected steady state for real users today —
production capture flows write at the assessment level
(`*ForAssessment*` events on `AgelessAssessmentView`); only
the Admin Test Tools UI exercises the person+platform write path that
populates this projection. The follow-up refactor collapses this
projection into a derived read over `AgelessAssessmentView`; until
then, 204 is the honest representation of "nothing was ever written
here for this person+platform."

The 204 is intentionally not declared via `ProducesResponseType`
because orval / MSW codegen surfaces 200+204 endpoints as
`void | T` in the generated client. The runtime contract is still
200-with-body or 204-no-body.
 */
export const getPersonalConsent = async (personId: string, platformId: string, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  return retrieveData<void>(getGetPersonalConsentUrl(personId, platformId), {
    ...options,
    method: "GET"
  });
};
export const getGetPersonalConsentQueryKey = (personId: string, platformId: string) => {
  return [`https://admin.ageless.ai/api/v1/ageless/consent/persons/${personId}/platforms/${platformId}`] as const;
};
export const getGetPersonalConsentQueryOptions = <TData = Awaited<ReturnType<typeof getPersonalConsent>>, TError = ErrorType<unknown>>(personId: string, platformId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonalConsent>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}) => {
  const {
    query: queryOptions,
    request: requestOptions
  } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getGetPersonalConsentQueryKey(personId, platformId);
  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonalConsent>>> = ({
    signal
  }) => getPersonalConsent(personId, platformId, {
    signal,
    ...requestOptions
  });
  return {
    queryKey,
    queryFn,
    enabled: personId !== null && personId !== undefined && platformId !== null && platformId !== undefined,
    ...queryOptions
  } as UseQueryOptions<Awaited<ReturnType<typeof getPersonalConsent>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};
export type GetPersonalConsentQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonalConsent>>>;
export type GetPersonalConsentQueryError = ErrorType<unknown>;
export function useGetPersonalConsent<TData = Awaited<ReturnType<typeof getPersonalConsent>>, TError = ErrorType<unknown>>(personId: string, platformId: string, options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonalConsent>>, TError, TData>> & Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getPersonalConsent>>, TError, Awaited<ReturnType<typeof getPersonalConsent>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPersonalConsent<TData = Awaited<ReturnType<typeof getPersonalConsent>>, TError = ErrorType<unknown>>(personId: string, platformId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonalConsent>>, TError, TData>> & Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getPersonalConsent>>, TError, Awaited<ReturnType<typeof getPersonalConsent>>>, "initialData">;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPersonalConsent<TData = Awaited<ReturnType<typeof getPersonalConsent>>, TError = ErrorType<unknown>>(personId: string, platformId: string, options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonalConsent>>, TError, TData>>;
  request?: SecondParameter<typeof retrieveData>;
}, queryClient?: QueryClient): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieves personal consent information for a person on a specific platform.

Returns 204 No Content when no consent row exists for the
person+platform pair (rather than 404). The shared CloudFront
distribution rewrites 4xx responses to `index.html` for SPA
routing, which would mask a 404 from this endpoint as an HTML payload;
204 sidesteps that. Splitting the API onto its own distribution is
tracked as follow-up work.

A missing row is the expected steady state for real users today —
production capture flows write at the assessment level
(`*ForAssessment*` events on `AgelessAssessmentView`); only
the Admin Test Tools UI exercises the person+platform write path that
populates this projection. The follow-up refactor collapses this
projection into a derived read over `AgelessAssessmentView`; until
then, 204 is the honest representation of "nothing was ever written
here for this person+platform."

The 204 is intentionally not declared via `ProducesResponseType`
because orval / MSW codegen surfaces 200+204 endpoints as
`void | T` in the generated client. The runtime contract is still
200-with-body or 204-no-body.
 */

export function useGetPersonalConsent(personId, platformId, options, queryClient) {
  const $ = _c(7);
  let t0;
  if ($[0] !== options || $[1] !== personId || $[2] !== platformId) {
    t0 = getGetPersonalConsentQueryOptions(personId, platformId, options);
    $[0] = options;
    $[1] = personId;
    $[2] = platformId;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const queryOptions = t0;
  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
  let t1;
  if ($[4] !== query || $[5] !== queryOptions.queryKey) {
    t1 = withQueryKey(query, queryOptions.queryKey);
    $[4] = query;
    $[5] = queryOptions.queryKey;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
export const getCaptureAssessmentBiometricConsentUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/assessments/${assessmentId}/biometric`;
};

/**
 * @summary Captures biometric consent for an assessment.
 */
export const captureAssessmentBiometricConsent = async (assessmentId: string, captureConsentRequest?: CaptureConsentRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getCaptureAssessmentBiometricConsentUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(captureConsentRequest)
  });
};
export const getCaptureAssessmentBiometricConsentMutationKey = () => ["captureAssessmentBiometricConsent"] as const;
export const getCaptureAssessmentBiometricConsentMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof captureAssessmentBiometricConsent>>, TError, CaptureAssessmentBiometricConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof captureAssessmentBiometricConsent>>, TError, CaptureAssessmentBiometricConsentMutationVariables, TContext> => {
  const mutationKey = getCaptureAssessmentBiometricConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureAssessmentBiometricConsent>>, CaptureAssessmentBiometricConsentMutationVariables> = props => {
    const {
      assessmentId,
      data
    } = props ?? {};
    return captureAssessmentBiometricConsent(assessmentId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type CaptureAssessmentBiometricConsentMutationResult = NonNullable<Awaited<ReturnType<typeof captureAssessmentBiometricConsent>>>;
export type CaptureAssessmentBiometricConsentMutationBody = BodyType<CaptureConsentRequest> | undefined;
export type CaptureAssessmentBiometricConsentMutationError = ErrorType<ProblemDetails>;
export type CaptureAssessmentBiometricConsentMutationVariables = {
  assessmentId: string;
  data?: BodyType<CaptureConsentRequest>;
};

/**
 * @summary Captures biometric consent for an assessment.
 */
export const useCaptureAssessmentBiometricConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getCaptureAssessmentBiometricConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getCaptureAssessmentConsumerHealthConsentUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/assessments/${assessmentId}/consumer-health`;
};

/**
 * @summary Captures consumer health consent for an assessment.
 */
export const captureAssessmentConsumerHealthConsent = async (assessmentId: string, captureConsentRequest?: CaptureConsentRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getCaptureAssessmentConsumerHealthConsentUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(captureConsentRequest)
  });
};
export const getCaptureAssessmentConsumerHealthConsentMutationKey = () => ["captureAssessmentConsumerHealthConsent"] as const;
export const getCaptureAssessmentConsumerHealthConsentMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof captureAssessmentConsumerHealthConsent>>, TError, CaptureAssessmentConsumerHealthConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof captureAssessmentConsumerHealthConsent>>, TError, CaptureAssessmentConsumerHealthConsentMutationVariables, TContext> => {
  const mutationKey = getCaptureAssessmentConsumerHealthConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureAssessmentConsumerHealthConsent>>, CaptureAssessmentConsumerHealthConsentMutationVariables> = props => {
    const {
      assessmentId,
      data
    } = props ?? {};
    return captureAssessmentConsumerHealthConsent(assessmentId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type CaptureAssessmentConsumerHealthConsentMutationResult = NonNullable<Awaited<ReturnType<typeof captureAssessmentConsumerHealthConsent>>>;
export type CaptureAssessmentConsumerHealthConsentMutationBody = BodyType<CaptureConsentRequest> | undefined;
export type CaptureAssessmentConsumerHealthConsentMutationError = ErrorType<ProblemDetails>;
export type CaptureAssessmentConsumerHealthConsentMutationVariables = {
  assessmentId: string;
  data?: BodyType<CaptureConsentRequest>;
};

/**
 * @summary Captures consumer health consent for an assessment.
 */
export const useCaptureAssessmentConsumerHealthConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getCaptureAssessmentConsumerHealthConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getCaptureAssessmentPromotionalMarketingConsentUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/assessments/${assessmentId}/promotional-marketing`;
};

/**
 * @summary Captures promotional marketing consent for an assessment.
 */
export const captureAssessmentPromotionalMarketingConsent = async (assessmentId: string, captureConsentRequest?: CaptureConsentRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getCaptureAssessmentPromotionalMarketingConsentUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(captureConsentRequest)
  });
};
export const getCaptureAssessmentPromotionalMarketingConsentMutationKey = () => ["captureAssessmentPromotionalMarketingConsent"] as const;
export const getCaptureAssessmentPromotionalMarketingConsentMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof captureAssessmentPromotionalMarketingConsent>>, TError, CaptureAssessmentPromotionalMarketingConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof captureAssessmentPromotionalMarketingConsent>>, TError, CaptureAssessmentPromotionalMarketingConsentMutationVariables, TContext> => {
  const mutationKey = getCaptureAssessmentPromotionalMarketingConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureAssessmentPromotionalMarketingConsent>>, CaptureAssessmentPromotionalMarketingConsentMutationVariables> = props => {
    const {
      assessmentId,
      data
    } = props ?? {};
    return captureAssessmentPromotionalMarketingConsent(assessmentId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type CaptureAssessmentPromotionalMarketingConsentMutationResult = NonNullable<Awaited<ReturnType<typeof captureAssessmentPromotionalMarketingConsent>>>;
export type CaptureAssessmentPromotionalMarketingConsentMutationBody = BodyType<CaptureConsentRequest> | undefined;
export type CaptureAssessmentPromotionalMarketingConsentMutationError = ErrorType<ProblemDetails>;
export type CaptureAssessmentPromotionalMarketingConsentMutationVariables = {
  assessmentId: string;
  data?: BodyType<CaptureConsentRequest>;
};

/**
 * @summary Captures promotional marketing consent for an assessment.
 */
export const useCaptureAssessmentPromotionalMarketingConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getCaptureAssessmentPromotionalMarketingConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getRevokeAssessmentPromotionalMarketingConsentUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/assessments/${assessmentId}/promotional-marketing`;
};

/**
 * @summary Revokes promotional marketing consent for an assessment.
 */
export const revokeAssessmentPromotionalMarketingConsent = async (assessmentId: string, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  return retrieveData<void>(getRevokeAssessmentPromotionalMarketingConsentUrl(assessmentId), {
    ...options,
    method: "DELETE"
  });
};
export const getRevokeAssessmentPromotionalMarketingConsentMutationKey = () => ["revokeAssessmentPromotionalMarketingConsent"] as const;
export const getRevokeAssessmentPromotionalMarketingConsentMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof revokeAssessmentPromotionalMarketingConsent>>, TError, RevokeAssessmentPromotionalMarketingConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof revokeAssessmentPromotionalMarketingConsent>>, TError, RevokeAssessmentPromotionalMarketingConsentMutationVariables, TContext> => {
  const mutationKey = getRevokeAssessmentPromotionalMarketingConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAssessmentPromotionalMarketingConsent>>, RevokeAssessmentPromotionalMarketingConsentMutationVariables> = props => {
    const {
      assessmentId
    } = props ?? {};
    return revokeAssessmentPromotionalMarketingConsent(assessmentId, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type RevokeAssessmentPromotionalMarketingConsentMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAssessmentPromotionalMarketingConsent>>>;
export type RevokeAssessmentPromotionalMarketingConsentMutationError = ErrorType<unknown>;
export type RevokeAssessmentPromotionalMarketingConsentMutationVariables = {
  assessmentId: string;
};

/**
 * @summary Revokes promotional marketing consent for an assessment.
 */
export const useRevokeAssessmentPromotionalMarketingConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getRevokeAssessmentPromotionalMarketingConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getDeleteBiometricImagesForPersonUrl = (personId: string, platformId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/biometric/persons/${personId}/platforms/${platformId}/images`;
};

/**
 * @summary Deletes all biometric images for a person on a platform and revokes
per-assessment biometric consent. Replaces images with a placeholder.
 */
export const deleteBiometricImagesForPerson = async (personId: string, platformId: string, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  return retrieveData<void>(getDeleteBiometricImagesForPersonUrl(personId, platformId), {
    ...options,
    method: "DELETE"
  });
};
export const getDeleteBiometricImagesForPersonMutationKey = () => ["deleteBiometricImagesForPerson"] as const;
export const getDeleteBiometricImagesForPersonMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteBiometricImagesForPerson>>, TError, DeleteBiometricImagesForPersonMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteBiometricImagesForPerson>>, TError, DeleteBiometricImagesForPersonMutationVariables, TContext> => {
  const mutationKey = getDeleteBiometricImagesForPersonMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBiometricImagesForPerson>>, DeleteBiometricImagesForPersonMutationVariables> = props => {
    const {
      personId,
      platformId
    } = props ?? {};
    return deleteBiometricImagesForPerson(personId, platformId, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type DeleteBiometricImagesForPersonMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBiometricImagesForPerson>>>;
export type DeleteBiometricImagesForPersonMutationError = ErrorType<unknown>;
export type DeleteBiometricImagesForPersonMutationVariables = {
  personId: string;
  platformId: string;
};

/**
 * @summary Deletes all biometric images for a person on a platform and revokes
per-assessment biometric consent. Replaces images with a placeholder.
 */
export const useDeleteBiometricImagesForPerson = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getDeleteBiometricImagesForPersonMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};
export const getCaptureAssessmentMarketingSmsConsentUrl = (assessmentId: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/consent/assessments/${assessmentId}/marketing-sms`;
};

/**
 * @summary Captures marketing SMS consent for an assessment. Used by the patient
results-unlock flow (in-office consults) after verify-phone, when the
patient opts in to marketing SMS. Requires the short-lived assessment
JWT; the route assessment id must match the token claim. Regional consent
text version and data-privacy region are resolved server-side.
 */
export const captureAssessmentMarketingSmsConsent = async (assessmentId: string, captureMarketingSmsConsentForAssessmentRequest?: CaptureMarketingSmsConsentForAssessmentRequest, options?: Parameters<typeof retrieveData>[1]): Promise<void> => {
  const getHeaders = (h?: NonNullable<RequestInit["headers"]>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(Array.from(h as Iterable<Iterable<string>>, entry => Array.from(entry) as [string, string]));
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return retrieveData<void>(getCaptureAssessmentMarketingSmsConsentUrl(assessmentId), {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getHeaders(options?.headers)
    },
    body: JSON.stringify(captureMarketingSmsConsentForAssessmentRequest)
  });
};
export const getCaptureAssessmentMarketingSmsConsentMutationKey = () => ["captureAssessmentMarketingSmsConsent"] as const;
export const getCaptureAssessmentMarketingSmsConsentMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof captureAssessmentMarketingSmsConsent>>, TError, CaptureAssessmentMarketingSmsConsentMutationVariables, TContext>;
  request?: SecondParameter<typeof retrieveData>;
}): UseMutationOptions<Awaited<ReturnType<typeof captureAssessmentMarketingSmsConsent>>, TError, CaptureAssessmentMarketingSmsConsentMutationVariables, TContext> => {
  const mutationKey = getCaptureAssessmentMarketingSmsConsentMutationKey();
  const {
    mutation: mutationOptions,
    request: requestOptions
  } = options ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey ? options : {
    ...options,
    mutation: {
      ...options.mutation,
      mutationKey
    }
  } : {
    mutation: {
      mutationKey
    },
    request: undefined
  };
  const mutationFn: MutationFunction<Awaited<ReturnType<typeof captureAssessmentMarketingSmsConsent>>, CaptureAssessmentMarketingSmsConsentMutationVariables> = props => {
    const {
      assessmentId,
      data
    } = props ?? {};
    return captureAssessmentMarketingSmsConsent(assessmentId, data, requestOptions);
  };
  return {
    mutationFn,
    ...mutationOptions
  };
};
export type CaptureAssessmentMarketingSmsConsentMutationResult = NonNullable<Awaited<ReturnType<typeof captureAssessmentMarketingSmsConsent>>>;
export type CaptureAssessmentMarketingSmsConsentMutationBody = BodyType<CaptureMarketingSmsConsentForAssessmentRequest> | undefined;
export type CaptureAssessmentMarketingSmsConsentMutationError = ErrorType<ProblemDetails>;
export type CaptureAssessmentMarketingSmsConsentMutationVariables = {
  assessmentId: string;
  data?: BodyType<CaptureMarketingSmsConsentForAssessmentRequest>;
};

/**
 * @summary Captures marketing SMS consent for an assessment. Used by the patient
results-unlock flow (in-office consults) after verify-phone, when the
patient opts in to marketing SMS. Requires the short-lived assessment
JWT; the route assessment id must match the token claim. Regional consent
text version and data-privacy region are resolved server-side.
 */
export const useCaptureAssessmentMarketingSmsConsent = (options, queryClient) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = getCaptureAssessmentMarketingSmsConsentMutationOptions(options);
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0, queryClient);
};